import { useAppSelector } from 'app/hooks';
import {
  AppsOutage,
  Dashboard,
  ExpandLess,
  ExpandMore,
  Settings,
  Share,
} from '@mui/icons-material';
import {
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import GridOnIcon from '@mui/icons-material/GridOn';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import WallList from 'features/walls/WallList';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import { StyledDrawerList } from './StyledDrawerList';

interface Props {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewsList = ({ drawerOpen, setDrawerOpen }: Props) => {
  const isAdmin = useIsAdmin();
  const selectedWallId = useAppSelector((state) => state.walls.selectedWallId);

  const [wallListOpen, setWallistOpen] = useState(false);
  const [alarmWallsOpen, setAlarmWallsOpen] = useState(false);

  const handleWallListClick = () => {
    setWallistOpen(!wallListOpen);
    setDrawerOpen(true);
  };

  const handleAlarmWallsClick = () => {
    setAlarmWallsOpen((state) => !state);
    setDrawerOpen(true);
  };

  useEffect(() => {
    if (selectedWallId === -1) return;
    setWallistOpen(true);
  }, [selectedWallId]);

  useEffect(() => {
    if (!drawerOpen) {
      setWallistOpen(false);
      setAlarmWallsOpen(false);
    }
  }, [drawerOpen]);

  return (
    <StyledDrawerList sx={{ padding: 0 }}>
      <ListItemButton component={Link} to='/' key={'Dashboard'}>
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary={'Dashboard'} />
      </ListItemButton>
      <ListItemButton onClick={handleWallListClick}>
        <ListItemIcon>
          <GridOnIcon />
        </ListItemIcon>
        <ListItemText primary='Walls' />
        {wallListOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={wallListOpen} timeout='auto' unmountOnExit>
        <WallList />
      </Collapse>
      <ListItemButton onClick={handleAlarmWallsClick}>
        <ListItemIcon>
          <AppsOutage />
        </ListItemIcon>
        <ListItemText primary='Alarm Walls' />
        {alarmWallsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={alarmWallsOpen} timeout='auto' unmountOnExit>
        <ListItemButton component={Link} to='/alarm-wall-history'>
          <ListItemText primary='History' />
        </ListItemButton>

        <ListItemButton component={Link} to='/alarm-wall-live'>
          <ListItemText primary='Live' />
        </ListItemButton>
      </Collapse>
      {isAdmin && (
        <ListItemButton component={Link} to='/share'>
          <ListItemIcon>
            <Share />
          </ListItemIcon>
          <ListItemText primary='Share' />
        </ListItemButton>
      )}
      <ListItemButton component={Link} to='/walls'>
        <ListItemIcon>
          <Settings />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary='Wall Configuration' />
        ) : (
          <ListItemText primary='Link' />
        )}
      </ListItemButton>
    </StyledDrawerList>
  );
};

export default ViewsList;
